import React from 'react';
import { compose, withHandlers } from 'recompose';
import { reduxForm, Field } from 'redux-form';
import { withRouter } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import withStyles from '@material-ui/core/styles/withStyles';
import { TextField } from 'redux-form-material-ui';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import { Select } from 'redux-form-material-ui';

const styles = theme => ({});

const enhance = compose(
  withStyles(styles),
  withRouter,
  withHandlers({}),
  reduxForm({ form: 'addCategoryForm' }),
);

export default enhance(({ classes, handleSubmit, edit, setEdit, history }) => (
  <form className={classes.form} onSubmit={handleSubmit}>
    <Grid container spacing={24}>
      {!edit && (
        <Grid item xs={12}>
          <Field name="id" component={TextField} label="ID" />
        </Grid>
      )}
      <Grid item xs={12}>
        <Field name="name" component={TextField} label="Název" />
      </Grid>
      <Grid item xs={12}>
        <Field name="description" component={TextField} label="Popis" />
      </Grid>
      <Grid item xs={12}>
        <FormControl style={{ minWidth: 200 }}>
          <InputLabel htmlFor={'unifiedItems'}>Výběr položek v rezervaci</InputLabel>
          <Field name={`unifiedItems`} component={Select} placeholder={'unifiedItems'}>
            {[{ label: 'ne', value: true }, { label: 'ano', value: false }].map(item => (
              <MenuItem key={item.label} value={item.value}>
                {item.label}
              </MenuItem>
            ))}
          </Field>
        </FormControl>
      </Grid>
    </Grid>
    <div style={{ margin: 20 }}>
      <Button type="submit" variant="contained" color="primary" className={classes.submit}>
        Uložit
      </Button>
      <Button
        variant="contained"
        color="secondary"
        onClick={() => (edit ? setEdit(false) : history.push('/categories'))}
      >
        Zrušit
      </Button>
    </div>
  </form>
));



// WEBPACK FOOTER //
// ./src/modules/categories/form/addForm.js